import * as THREE from "three";
import { state } from "../state";

export function isFragmentsActive(): boolean {
  return Boolean(state.fragmentsModelId);
}

export function getGeometryExpressIds(): number[] {
  return state.geometryExpressIds ?? [];
}

export async function focusOnExpressIdsFragments(expressIds: number[]): Promise<void> {
  if (!state.fragmentsModelId || expressIds.length === 0) {
    return;
  }
  const { getActiveFragmentsModel } = await import("./engine");
  const { camera, controls } = await import("../viewer/scene");
  const model = getActiveFragmentsModel(state.fragmentsModelId);
  if (!model) {
    return;
  }
  const box = await model.getMergedBox(expressIds);
  if (!box || box.isEmpty()) {
    return;
  }
  const worldCenter = box.getCenter(new THREE.Vector3());
  const size = box.getSize(new THREE.Vector3());
  const maxSize = Math.max(size.x, size.y, size.z, 0.5);
  const fitDistance = maxSize * 2.2;

  if (state.planView.active) {
    const { refitPlanToBox } = await import("../features/planView");
    refitPlanToBox(box);
    return;
  }

  camera.near = Math.max(0.05, fitDistance / 500);
  camera.far = Math.max(2000, fitDistance * 30);
  camera.updateProjectionMatrix();

  const direction = camera.position.clone().sub(controls.target).normalize();
  if (!Number.isFinite(direction.x) || direction.lengthSq() < 0.0001) {
    direction.set(1, 0.7, 1).normalize();
  }
  camera.position.copy(worldCenter).addScaledVector(direction, fitDistance);
  controls.target.copy(worldCenter);
  controls.update();
}

export async function getExpressIdBoundingCenter(expressId: number): Promise<THREE.Vector3 | null> {
  if (!state.fragmentsModelId) {
    return null;
  }
  const { getActiveFragmentsModel } = await import("./engine");
  const model = getActiveFragmentsModel(state.fragmentsModelId);
  if (!model) {
    return null;
  }
  const boxes = await model.getBoxes([expressId]);
  const box = boxes[0];
  if (!box || box.isEmpty()) {
    return null;
  }
  return box.getCenter(new THREE.Vector3());
}
